import { IS_DEVELOPMENT } from "@/utils/env";

// Feature flags for controlling UI visibility and behavior
export const FEATURES = {
  // Show difficulty level badges in exam reports
  SHOW_REPORT_DIFFICULTY_LEVEL: false,

  // 시험 결과 페이지 표시 여부
  ShowExamResultPage: true,

  // 향후 추가될 기능들을 위한 예약
  // ShowReportsPage: false,
  // ShowAnalyticsPage: false,
} as const;

export type FeatureKey = keyof typeof FEATURES;

// 하위 호환성을 위한 별칭
export const FEATURE_FLAGS = FEATURES;

export default FEATURES;
